import { ApiClient } from "./ApiClient";
import { JournalName } from "../models/JournalName.ts";

const JournalNameController = {
    get: () => {
        return ApiClient.get('journalNames');
    },
    put: (journalNames: JournalName[]) => {
        return ApiClient.put('journalNames', { journalNames: journalNames });
    }
};
export default JournalNameController;